import './SelectInputCalendar.css'

import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core'
import { CheckSharp } from '@material-ui/icons'
import React from 'react'

export default function SelectInputCalendar({
  label,
  value,
  onChange,
  handleOnKeyPress,
  onClose,
  items = [],
  name,
  icon = <CheckSharp />,
  defaultIcon = true,
  required,
  inputProps,
  variant = 'standard',
  ...rest
}) {
  const MAX_HEIGHT = 216
  const onOpen = (e) => {
    if (e.code === 'Enter') {
      e.preventDefault()
    }
  }
  return (
    <FormControl className="wrapper_select_input_calendar" variant={variant}>
      <Grid container alignItems="flex-end">
        <Grid item className="icon--check">
          {!defaultIcon ? '' : icon}
        </Grid>
        <Grid item>
          <InputLabel
            id="label"
            disableAnimation={true}
            className={`${!value ? 'label_unshink' : ''} ${required ? ' require_label' : ''}`}
          >
            {label}
          </InputLabel>
          <Select
            labelId="label"
            value={value}
            name={name}
            onChange={onChange}
            onKeyPress={handleOnKeyPress}
            onClose={onClose}
            onOpen={onOpen}
            inputProps={{ ...inputProps }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: MAX_HEIGHT,
                },
              },
              MenuListProps: {
                style: {
                  fontSize: 12,
                },
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
            }}
            {...rest}
          >
            {items.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    </FormControl>
  )
}
